import React from "react"
import { Container, Row, Col } from "reactstrap"

// Django-rendered pages — plain anchors, matching the external nav links they replace.
const UPLOAD_LINKS = [
    { name: "Bulk Upload", href: "/billing/bulk_upload/" },
    { name: "Toll Upload", href: "/billing/upload_tolls/" },
    { name: "Tickets Upload", href: "/billing/import_tickets/" },
]

const UploadsContainer = () => (
    <Container fluid className="bos-listing-container">
        <Row>
            <Col>
                <ul>
                    {UPLOAD_LINKS.map(link => (
                        <li key={link.href}>
                            <a href={link.href} target="_blank" rel="noopener noreferrer">{link.name}</a>
                        </li>
                    ))}
                </ul>
            </Col>
        </Row>
    </Container>
)

export { UPLOAD_LINKS }
export default UploadsContainer
